export const DEFAULT_RADIUS = null
export const DEFAULT_SLOP = 1
